// extracted by mini-css-extract-plugin
export default {"help-button":"summary_help-button__DGrjY","link":"summary_link__SVqCt"};